import { MerchOrderInterface } from 'app/shared/interfaces/MerchOrder.interface';

export function hasPersistedMerchOrderData(
  order?: MerchOrderInterface
): boolean {
  if (!order) {
    return false;
  }

  return (
    order.consents?.merchOrder?.consent === true ||
    Boolean(order.firstName) ||
    Boolean(order.email)
  );
}
